import { LocalDateTime } from '../../../../shared/jsr310-localdates/types/local-date-time.type';

import { EtatOuvrage } from './etat-ouvrage.entity';
import { ArretSlbTLR } from '../../arret-slb/entities/arret-slb-tlr.entity';
import { NotifiableByMailOrder } from './has-id.interface';

export class FermetureAccesOrder implements NotifiableByMailOrder {
	forceMailsAsTest?: boolean;
	
	constructor(
		public accesId: number,
		public dateFin: LocalDateTime,
		public etatOuvrages: EtatOuvrage[],
		public porteFermee: boolean = false,
		public ouvragesConcernes: number[],
		public arretMachine: boolean | null,
		public arrets: ArretSlbTLR[],
		public commentaireArrets: string,
		public codesCarlOperations: string[],
		public commentaireFermeture: string,
		public shouldSignalAbsenceArret:  boolean | null,
	) {
	}
}